import React from 'react';
import {
  RefreshButtonTextProps,
  reloadButton,
} from '@components/sources/visualizer/mappingScreens/config/mappingConfig/SelectUniqueIdentifier';
import RefreshButton from '@components/sources/visualizer/mappingScreens/config/mappingConfig/refreshButton';
import { getApiErrorMessage } from '@components/common/util/util';
import useStores from '@stores/useStores';
import {
  fetchErrorAssets,
  ErrorProps,
} from '@components/sources/visualizer/mappingScreens/errorsView';
import { IColumn } from './sourceSpecificConfig';
import { ISourceInfo } from './tableMapping/tableMappingProvider';

interface ReloadColumnsProps {
  refreshColumns: (columns: IColumn[]) => void;
  hide: boolean;
  sourceConfig?: ISourceInfo;
  role: string;
  updateSchemaErrors: (errorItems: ErrorProps[]) => void;
}

const ReloadColumns: React.FC<ReloadColumnsProps> = ({
  refreshColumns,
  hide,
  sourceConfig,
  role,
  updateSchemaErrors,
}: ReloadColumnsProps) => {
  const { messagesStore, sourceDataStore } = useStores();

  const fetchColumns = async () => {
    updateSchemaErrors([fetchErrorAssets('columns')]);
    const columnProps: IColumn[] = (await sourceDataStore.getColumns(sourceConfig, role)) || [];
    return columnProps;
  };
  const refreshColumnsButton = (buttonProperties: RefreshButtonTextProps) =>
    reloadButton(buttonProperties, 'columns');
  return (
    <RefreshButton
      hide={hide}
      onComplete={refreshColumns}
      fetchDataOnClick={fetchColumns}
      ButtonComp={refreshColumnsButton}
      onIncomplete={(err) => {
        const errMsg = getApiErrorMessage(err, 'Failed to reload columns');
        messagesStore.showErrorMessage(errMsg);
        updateSchemaErrors([fetchErrorAssets('columns', errMsg)]);
      }}
    />
  );
};
export default ReloadColumns;
